var _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12173"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15541",
    d: "M17.094 19.004h-5.728a1.876 1.876 0 01-1.91-1.91v-5.728a1.876 1.876 0 011.91-1.91h5.729a1.876 1.876 0 011.91 1.91v5.729a1.876 1.876 0 01-1.911 1.909zm-5.728-8.275a.6.6 0 00-.637.637v5.729a.6.6 0 00.637.637h5.729a.6.6 0 00.637-.637v-5.729a.6.6 0 00-.637-.637z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12174"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15542",
    d: "M7.546 14.548H6.91A1.876 1.876 0 015 12.638V6.91A1.876 1.876 0 016.91 5h5.728a1.876 1.876 0 011.91 1.91v.637a.637.637 0 11-1.273 0V6.91a.6.6 0 00-.637-.637H6.91a.6.6 0 00-.637.637v5.728a.6.6 0 00.637.637h.637a.637.637 0 110 1.273z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15110",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgDuplicateIcon;